App.SurveyTable = class extends App.DataTable {
  constructor(table) {
    const dataSourceUrl = '/rmg/admin/surveys/data_table';

    const columns = [
      {
        sortable: false,
        width: 160,
        title: '',
        render: function( data, type, full, meta ) {
          return [
            full.edit_link,
            ' ', // space puts space between the links
            full.duplicate_link,
          ].join('')
        }
      },
      { 
        data: 'policy_year',
        render: (data, type, full, meta ) => { 
          return `${ full.policy_year }-${ full.policy_year + 1 }` 
        }
      },
      { data: 'status' },
      { data: "updated_at" }
    ];

    let searchFilterHtml = {
      'filter-status': "<select class='form-control input-sm'><option value=''>Any</option><option>Active</option><option>Archived</option><option>Pending</option>"
    };

    super({ table: table,
            dataSourceUrl: dataSourceUrl,
            columns: columns,
            noData: null,
            pageLength: null,
            searchFilterHtml: searchFilterHtml
          });

  }
}

$(document).on('turbo:load', function() {
  if($(".surveys.index").length == 0) return;

  var surveyTable = new App.SurveyTable($("#survey_table"));
  surveyTable.render();
});
